// extracted by mini-css-extract-plugin
module.exports = {"item":"_68fa33","item__avatar":"_53c16b","item__avatar--highlighted":"c1e57c","item__name":"_3a483b","item-selected":"_9c9124"};